var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "MultipleToggle",
        {
          attrs: {
            options: _vm.toggleOptions,
            value: _vm.viewModel.callRouteDuplicateToggle,
            disabled: _vm.disabled
          },
          on: { change: _vm.handleToggleChange }
        },
        [
          _vm.viewModel.callRouteDuplicateToggle ===
          _vm.DUPLICATE_CONVERSION_VALUES.TIME_LIMIT
            ? _c("div", { staticClass: "form-group p-l-0 p-b-0 mt-2" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-3 col-md-2 m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.viewModel.deDupeSetting.days,
                          expression: "viewModel.deDupeSetting.days",
                          modifiers: { number: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        min: "0",
                        step: "1",
                        readonly: _vm.disabled
                      },
                      domProps: { value: _vm.viewModel.deDupeSetting.days },
                      on: {
                        change: _vm.handleTimeLimitChange,
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.viewModel.deDupeSetting,
                            "days",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "control-label text-left col-sm-2 col-md-1"
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("DAYS")) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3 col-md-2 m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.viewModel.deDupeSetting.hours,
                          expression: "viewModel.deDupeSetting.hours",
                          modifiers: { number: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        min: "0",
                        step: "1",
                        readonly: _vm.disabled
                      },
                      domProps: { value: _vm.viewModel.deDupeSetting.hours },
                      on: {
                        change: _vm.handleTimeLimitChange,
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.viewModel.deDupeSetting,
                            "hours",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "control-label text-left col-sm-2 col-md-1 text-left"
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("HOURS")) + "\n        "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }